<div *ngIf="checkbox != null; else content" class="checkbox-wrapper">
  <super-table-checkbox
    [value]="checkbox"
    [checkboxDisabled]="checkboxDisabled"
    class="rv-left sticky-left checkbox"
  ></super-table-checkbox>
</div>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
